import { useCallback } from "react";
import { useApiBase } from '../base/api-baixas-base'
import { CadastrarModel } from "../../../model/api/Cadastrar";

export const usePostCadastrar = () => {
    const { invocarApi, ...props } = useApiBase();
    const postCadastrar = useCallback(
        (model : CadastrarModel) => {
            return invocarApi({
                url: 'v1/Operacao/contato/registrar-contato',
                method: 'POST',
                enviarTokenUsuario: false,
                data: model
            })
        },
        [invocarApi],
    )
    return {                
        postCadastrar,
        ...props
    }
}
